import React from 'react';
import type { FC } from 'react';

import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { Hiring__Question__Input, Status, useHiringQuestionCreateMutation } from '@admin/schema';

import { HiringQuestionForm } from './form';

export const HiringQuestionNew: FC = () => {
  useTitle('Hiring | Pre-Screen Questions | New');
  const [execute, { loading: saving, data }] = useHiringQuestionCreateMutation({
    client,
    onCompleted: ({ result }) => {
      if (result?.status === Status.Ok) window.location.href = '/hiring/pre_screen_questions';
    },
  });

  const save = (input: Hiring__Question__Input) => {
    execute({ variables: { input } });
  };

  const error = data?.result?.error;

  return <HiringQuestionForm save={save} saving={saving} error={error} />;
};
